<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'time-off-v3.timeOffRequests' | translate }}" [menuService]="tabMenuService"></app-header>
    <ui-card class="overflow-hidden" [withMargin]="false" [withSpacing]="false">
        <app-table
            class="h-100"
            [noPadding]="true"
            [useStickyHeader]="false"
            [showOffset]="false"
            [isResponsive]="true"
            [embedded]="true"
            [table]="timeOffTeamRequestTable"
        >
            <app-empty-state
                label="{{ 'time-off-v3.noRequestsFound' | translate }}"
                src="/assets/illustrations/calendar.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
